import { CoreMenu } from '@core/types';

/**
 * Menu latéral Vuexy — reprend toutes les entrées de l’ancien menu interne Paramètres.
 */
export const menu: CoreMenu[] = [
  {
    id: 'Parametre',
    type: 'section',
    title: 'Paramètres',
    translate: 'Paramètres',
    icon: 'settings',
    children: [
      {
        id: 'parametre-entreprise',
        title: "Profil de l'entreprise",
        translate: "Profil de l'entreprise",
        type: 'item',
        icon: 'briefcase',
        url: 'main/parametre/entreprise',
      },
      {
        id: 'parametre-document',
        title: 'Paramètres des documents',
        translate: 'Paramètres des documents',
        type: 'item',
        icon: 'file-text',
        url: 'main/parametre/document',
      },
      {
        id: 'parametre-compte-bancaire',
        title: 'Compte bancaire',
        translate: 'Compte bancaire',
        type: 'item',
        icon: 'credit-card',
        url: 'main/parametre/compte-bancaire',
      },
      {
        id: 'parametre-taxe-tva',
        title: 'Taxes et TVA',
        translate: 'Taxes et TVA',
        type: 'item',
        icon: 'percent',
        url: 'main/parametre/taxe-tva',
      },
      {
        id: 'parametre-liste-prix',
        title: 'Liste de prix',
        translate: 'Liste de prix',
        type: 'item',
        icon: 'tag',
        url: 'main/parametre/liste-prix',
      },
      {
        id: 'parametre-comptable',
        title: 'Comptable',
        translate: 'Comptable',
        type: 'item',
        icon: 'book',
        url: 'main/parametre/comptable-parametre',
      },
      {
        id: 'parametre-users',
        title: 'Utilisateurs et rôles',
        translate: 'Utilisateurs et rôles',
        type: 'item',
        icon: 'users',
        url: 'main/parametre/user-and-role',
      },
      {
        id: 'parametre-integration',
        title: 'Intégration',
        translate: 'Intégration',
        type: 'item',
        icon: 'link',
        url: 'main/parametre/integration',
      },
      {
        id: 'parametre-projets',
        title: 'Projets',
        translate: 'Projets',
        type: 'item',
        icon: 'folder',
        url: 'main/parametre/projets',
      },
      {
        id: 'parametre-marque-categorie',
        title: 'Marques, Catégories et Unités',
        translate: 'Marques, Catégories et Unités',
        type: 'item',
        icon: 'grid',
        url: 'main/parametre/marque-categorie/categories',
      },
    ],
  },
  {
    id: 'LogicielCaisse',
    type: 'section',
    title: 'Logiciel de caisse',
    translate: 'Logiciel de caisse',
    icon: 'monitor',
    children: [
      {
        id: 'parametre-logiciel-caisse',
        title: 'Configuration caisse',
        translate: 'Configuration caisse',
        type: 'item',
        icon: 'layout',
        url: 'main/parametre/logiciel-caisse',
      },
      {
        id: 'parametre-etablissements',
        title: 'Établissements',
        translate: 'Établissements',
        type: 'item',
        icon: 'briefcase',
        url: 'main/parametre/etablissements',
      },
      {
        id: 'parametre-entrepots',
        title: 'Entrepôts',
        translate: 'Entrepôts',
        type: 'item',
        icon: 'home',
        url: 'main/parametre/entrepots',
      },
      {
        id: 'parametre-caisses',
        title: 'Caisses',
        translate: 'Caisses',
        type: 'item',
        icon: 'monitor',
        url: 'main/parametre/caisses',
      },
      {
        id: 'parametre-affectations-lc',
        title: 'Affectations',
        translate: 'Affectations',
        type: 'collapsible',
        icon: 'link-2',
        expanded: true,
        children: [
          {
            id: 'parametre-vendeur-caisse',
            title: 'Vendeurs et caisses',
            translate: 'Vendeurs et caisses',
            type: 'item',
            icon: 'circle',
            url: 'main/parametre/vendeur-caisse',
          },
          {
            id: 'parametre-gerant-entrepot',
            title: 'Gérants et entrepôts',
            translate: 'Gérants et entrepôts',
            type: 'item',
            icon: 'circle',
            url: 'main/parametre/gerant-entrepot',
          },
          {
            id: 'parametre-commerciaux',
            title: 'Commerciaux — entrepôt associé',
            translate: 'Commerciaux — entrepôt associé',
            type: 'item',
            icon: 'circle',
            url: 'main/parametre/commerciaux',
          },
        ],
      },
      {
        id: 'parametre-ticket-templates',
        title: 'Templates ticket',
        translate: 'Templates ticket',
        type: 'item',
        icon: 'printer',
        url: 'main/parametre/ticket-templates',
      },
      {
        id: 'parametre-modes-paiement',
        title: 'Modes de paiement',
        translate: 'Modes de paiement',
        type: 'item',
        icon: 'credit-card',
        url: 'main/parametre/modes-paiement',
      },
      {
        id: 'parametre-reasort',
        title: 'Réassort',
        translate: 'Réassort',
        type: 'item',
        icon: 'refresh-cw',
        url: 'main/parametre/reasort',
      },
    ],
  },
];
